import { createContext, useContext, useState } from 'react'

import { ConfigurationData } from '@/types'

export interface ConfigurationContextValue {
  values: ConfigurationData[]
  getConfigById(_id: number): ConfigurationData | undefined
  getConfigByProperty: (_id: string) => ConfigurationData | undefined
}

export const ConfigurationContext = createContext<
  ConfigurationContextValue | undefined
>(undefined)

interface ConfigurationContextProviderProps {
  values: ConfigurationData[]
  children?: React.ReactNode
}

export const ConfigurationContextProvider: React.FC<
  ConfigurationContextProviderProps
> = ({ values: initialValues = [], children }) => {
  const [values] = useState<ConfigurationData[]>(initialValues)

  const getConfigById = (id: number): ConfigurationData | undefined => {
    return values.find((config) => config.id === id)
  }

  const getConfigByProperty = (
    property: string
  ): ConfigurationData | undefined => {
    return values.find((config) => config.property === property)
  }

  return (
    <ConfigurationContext.Provider
      value={{ values, getConfigById, getConfigByProperty }}
    >
      {children}
    </ConfigurationContext.Provider>
  )
}

export const useConfiguration = () => {
  const context = useContext(ConfigurationContext)
  if (context === undefined) {
    throw new Error('useConfiguration was used outside of its Provider')
  }
  return context
}
